export default {
	"classify.ProductRequestError": "商品请求错误",
	"classify.RequestError": "请求错误",
	"classify.MarketingMarketplaceListPage": "营销商城列表页",
	"classify.MarketingMarketplace": "营销商城",
	"classify.all": "全部",
	"classify.CommodityAcquisition": "商品获取...",
	"classify.MarketingMarketplaceListingPageProductClick": "营销商城列表页_商品点击",
	"classify.AListOfStoreItems": "店铺商品列表"
}